export const CALC_BLACKLIST_ROUTE_PREFIX = "/settings/calc-blacklists";

export const CALC_BLACKLIST_ROUTE_PATHS = {
  list: { path: "*", to: CALC_BLACKLIST_ROUTE_PREFIX },
};
